export const publicKey = `
-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDm5z5qG1hyrBWfp+G3U2RLCu616J3tR9x9EwJLMKgNBT+O+Zk/A96/nlnY++FabQLcYG0Xj5QivgITmcYGiuSOqUhKdX0eYdXBIyNg/1EmR06ED1mHdfTmKj4CX5Pr0PfiKvBoGn80pH7JO/gvH8ubpA70+DA4fbQrrkSS6F4otQIDAQAB
-----END PUBLIC KEY-----
`